import { TransportNotificationContactDto, CompanySmsServiceUrlDto } from '@/__generated';
import CreateBtn from '@/components/app/CreateBtn';
import ReloadBtn from '@/components/app/ReloadBtn';
import CountryInput from '@/components/FormItems/CountryInput';
import CountryPhoneCodeInput from '@/components/FormItems/CountryPhoneCodeInput';
import ZTable, { IColumnType, ITableRef } from '@/components/ZTable';
import { ROW_GUTTER } from '@/config';
import { NotificationContactType } from '@/constants';
import { apiSdk } from '@/httpClient';
import { Card, Col, Form, Input, message, Row, Space, Spin } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';


const contactColumns: IColumnType<TransportNotificationContactDto>[] = [
  {
    title: 'companySettingsPage_ContactName',
    dataIndex: 'contactName',
  },
  {
    title: 'companySettingsPage_ContactPhoneNumber',
    dataIndex: 'contactValue',
    render: (v, record) => `(${record.countryPhoneCode}) ${v}`,
  },
];
const smsColumns: IColumnType<CompanySmsServiceUrlDto>[] = [
  {
    title: 'base.Country',
    dataIndex: 'countryName',
    render: (v, record) => `(${record.countryCode}) ${v}`,
  },
  {
    title: 'companySettingsPage_ServiceUrl',
    dataIndex: 'smsServiceUrl',
  },
];
export default function NotificationTab() {
  const { t } = useTranslation();
  const [contactForm] = Form.useForm();
  const contactTable = React.useRef<ITableRef>();
  const [contactLoading, setContactLoading] = React.useState<boolean>(false);
  const [smsForm] = Form.useForm();
  const smsTable = React.useRef<ITableRef>();
  const [smsLoading, setSmsLoading] = React.useState<boolean>(false);
  const onCreateSmsContact = (values: any) => {
    setContactLoading(false);
    apiSdk.NotificationContactService.create({
      body: {
        ...values,
        notificationType: NotificationContactType.SMS,
      },
    })
      .then(response => {
        if (response?.success) {
          contactForm.resetFields();
          contactTable.current?.reload();
        } else {
          if (response.message) {
            message.error(t(response.message || ''));
          }
        }
      })
      .catch(error => {
        message.error(error);
      })
      .finally(() => {
        setContactLoading(false);
      });
  };
  const onCreateSmsSetting = values => {
    setSmsLoading(true);
    apiSdk.CompanySmsServiceUrlService.create({
      body: values,
    })
      .then(response => {
        if (response?.success) {
          smsForm.resetFields();
          smsTable.current?.reload();
        } else {
          if (response.message) {
            message.error(t(response.message || ''));
          }
        }
      })
      .catch(error => {
        message.error(error);
      })
      .finally(() => {
        setSmsLoading(false);
      });
  };
  return (
    <Row gutter={ROW_GUTTER}>
      <Col md={12}>
        <Spin spinning={contactLoading}>
          <Card className="mtopo-card" size="small" title={t('companySettingsPage_NotificationContacts')}>
            <Form form={contactForm} layout="vertical" onFinish={onCreateSmsContact}>
              <Row gutter={ROW_GUTTER}>
                <Col md={8}>
                  <Form.Item rules={[{ required: true, message: '' }]} label={t('companySettingsPage_ContactName')} name="contactName">
                    <Input />
                  </Form.Item>
                </Col>
                <Col md={8}>
                  <Form.Item label={t('companySettingsPage_ContactPhoneNumber')} style={{ marginBottom: 0 }}>
                    <Space>
                      <Form.Item rules={[{ required: true, message: '' }]} name="countryPhoneCode">
                        <CountryPhoneCodeInput style={{ width: 100 }} placeholder={t('base.Code')} />
                      </Form.Item>
                      <Form.Item rules={[{ required: true, message: '' }]} name="contactValue">
                        <Input />
                      </Form.Item>
                    </Space>
                  </Form.Item>
                </Col>
                <Col md={8}>
                  <Form.Item label="   ">
                    <Space>
                      <CreateBtn htmlType="submit" />
                      <ReloadBtn
                        onClick={() => {
                          contactTable.current?.reload();
                        }}
                      />
                    </Space>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            <ZTable
              tableRef={contactTable}
              columns={contactColumns}
              primaryKey="id"
              defaultVariables={{ notificationType: NotificationContactType.SMS }}
              url="/commons/notification-contacts/get-notification-contacts"
              bordered
              order_by="createdOn"
              order_by_asc={false}
              allowEdit={false}
              allowDelete={true}
              delete_url="/commons/notification-contacts/delete"
            />
          </Card>
        </Spin>
      </Col>
      <Col md={12}>
        <Spin spinning={smsLoading}>
          <Card className="mtopo-card" size="small" title={t('companySettingsPage_SMSServiceSetting')}>
            <Form form={smsForm} layout="vertical" onFinish={onCreateSmsSetting}>
              <Row gutter={ROW_GUTTER}>
                <Col md={6}>
                  <Form.Item rules={[{ required: true, message: '' }]} label={t('base.Country')} name="countryId">
                    <CountryInput />
                  </Form.Item>
                </Col>
                <Col md={12}>
                  <Form.Item rules={[{ required: true, message: '' }]} label={t('companySettingsPage_ServiceUrl')} name="smsServiceUrl">
                    <Input />
                  </Form.Item>
                </Col>
                <Col md={6}>
                  <Form.Item label="   ">
                    <Space>
                      <CreateBtn htmlType="submit" />
                      <ReloadBtn
                        onClick={() => {
                          smsTable.current?.reload();
                        }}
                      />
                    </Space>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            <ZTable
              tableRef={smsTable}
              columns={smsColumns}
              primaryKey="id"
              url="/commons/company-sms-service-urls/get-service-urls"
              bordered
              order_by="createdOn"
              order_by_asc={false}
              allowEdit={false}
              allowDelete={true}
              delete_url="/commons/company-sms-service-urls/delete"
            />
          </Card>
        </Spin>
      </Col>
    </Row>
  );
}
